import { useMutation, useQueryClient } from 'react-query'
import { getTppCellsQueryKey } from '../../../../../components/TppView/hooks/useTppData'
import { useAuth0 } from '../../../../../contexts/auth0-context'
import callAPI from '../../../../../API/callSecureAPI'
import endpoints from '../../../../../API/endpoints'
import { TPPCell } from './useTPPCellQuery'
import { useInvalidateTPPChangeLogQuery } from '../../../../../components/TPPChangeLog/queries/useInvalidateTPPChangeLogQuery'

type CloneTPPCellPayload = {
    cellId: string
    tppId: string
    columnId: string
}

type UseCloneTPPCellMutationProps = {
    onSuccess?: () => void
}

export const useCloneTPPCellMutation = ({ onSuccess }: UseCloneTPPCellMutationProps = {}) => {
    const { getTokenSilently } = useAuth0()
    const queryClient = useQueryClient()
    const { invalidateTPPChangeLogQuery } = useInvalidateTPPChangeLogQuery()

    const cloneTPPCell = async ({ cellId, columnId }: CloneTPPCellPayload) => {
        const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        const { url, method } = endpoints.cloneTPPCell
        const response = await callAPI(`${url.replace(':cellId', cellId)}`, method, token, { columnId })
        return response.data
    }

    return useMutation(cloneTPPCell, {
        onSuccess: async (data, variables) => {
            const { cells } = data

            queryClient.setQueryData<TPPCell[]>(getTppCellsQueryKey(variables.tppId), (old) => {
                if (!old) return cells
                const next = [...old]
                cells.forEach((cell: TPPCell) => {
                    const idx = next.findIndex((c) => c._id === cell._id)
                    if (idx > -1) next[idx] = cell
                    else next.push(cell)
                })
                return next
            })

            invalidateTPPChangeLogQuery(variables.tppId)
            onSuccess?.()
        },
    })
}
